import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { prettyLocalDate } from '../../../lib/time';
import {formatCurrency} from '../../../lib/currency';

const useStyles = makeStyles({
  summary: {
    border: 'solid 1px #b5b5b5',
    borderRadius: 4,
    margin: '1rem 0 1rem 0',
  }
});

const MatchingFees = ({matchingFees}) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.summary}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {matchingFees.items.map(item =>
            <TableRow key={item.id}>
              <TableCell>
                {item.description}
              </TableCell>
              <TableCell align="right">{formatCurrency(item.amount.excl)}</TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell>GST</TableCell>
            <TableCell align="right">
              {formatCurrency(matchingFees.total.gst)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total (including GST)</TableCell>
            <TableCell align="right">
              {formatCurrency(matchingFees.total.incl)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Next Payment Date: {matchingFees.overdue ? 'Today' : prettyLocalDate(matchingFees.due_date)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

MatchingFees.propTypes = {
  matchingFees: PropTypes.object.isRequired,
};

export default MatchingFees;
